import React, { useState } from 'react';
import { Icon } from '@paypalcorp/pp-react';
import styles from './SetPreferredHeart.less';

const SetPreferredHeart = ({ selected, hubFlow }) => {
  return selected ? (
    <Icon
      alt='set-favorite-heart'
      className={styles['heart-filled']}
      name='favorite-selected'
      size={hubFlow ? 'md' : 'sm'}
      data-nemo='npo-heart-filled'
    />
  ) : (
    <Icon
      alt='set-favorite-heart'
      className={styles['heart-empty']}
      name='favorite'
      size={hubFlow ? 'md' : 'sm'}
    />
  );
};

export default SetPreferredHeart;
